import { all, SagaContext } from 'async-saga';
import { actions } from '..';
import { redirectToLogin } from '../..';
import * as api from '../../api';
import { delay } from '../../promise-utils';
import { getConfig } from '../reducers/config';
import { selectInIpfxMobility } from '../reducers/localSettings';
import { take } from '../tools/async-saga-types';
import { selectCall } from 'webrtc-client-janus';

async function pingWebsocket(ctx: SagaContext) {
  await take(ctx, actions.setConfig)
  const interval = 120000
  const setTimer = () => setTimeout(onTimer, interval)
  let timerId = setTimer()

  async function onTimer() {
    const store = ctx.getState()
    const config = getConfig(store)
    const pong = take(ctx, actions.pong)

    try {
      console.info('Pinging server')
      api.ping(config !== null ? config.clientId : '')
    } catch (e) {
      api.processApiError(e, ctx.dispatch)
    }

    const result = await Promise.race([
      pong.then(() => true),
      delay(30 * 1000).then(() => false),
    ])

    if (!result) {
      console.error('Pong did not come back')
      ctx.dispatch(actions.pongFailed())
    }

    if (timerId) {
      clearTimeout(timerId)
    }

    timerId = setTimer()
  }
}

async function onSessionExpired(ctx: SagaContext) {
  await take(ctx, actions.sessionExpired)

  console.info('onSessionExpired')

  //if mobility client ignore pop and redirect
  const store = ctx.getState()

  const ipfxMobilityClient = selectInIpfxMobility(store)
  const call = selectCall(store)

  //if on a call then we will not do anything
  if ((call != null && call.canHangUp)) {
    console.info('on a web rtc call so not redirecting')
    return
  } else {
    if (ipfxMobilityClient) {
      redirectToLogin(window.location.search)
    } else {
      //we used to show a message but now we are not
      redirectToLogin(window.location.search)
    }
  }
}

async function onRedirectToLogin(ctx: SagaContext) {
  await take(ctx, actions.redirectToLogin)
  redirectToLogin(window.location.search)
}

export default all(
  pingWebsocket,
  onSessionExpired,
  onRedirectToLogin,
)
